module.exports = {
	"basket": {
		"review": {
			"content": "\"Nem og sikker oprettelse af testamente. Anbefaler klart at bruge det.\"",
			"name": "Kenneth Tange"
		},
		"next": {
			"title": "Efter dit køb",
			"description": "Du kan fortsat redigere dine dokumenter efter dit køb.",
			"description_registration": "TestaViva tinglyser dit dokument for dig. Du får besked, når dit dokument er klar til at du kan underskrive.",
			"digital_document_basis": {
				"pre_created": "Du skal udfylde {product}.",
				"post_created": {
					"will": "Dit testamente skal underskrives.",
					"prenup": "Din ægtepagt skal tinglyses.",
					"favored": "Din begunstigelseserklæring skal underskrives.",
					"coop": "Din samejekontrakt skal underskrives.",
					"future_pow": "Din fremtidsfuldmagt skal tinglyses.",
					"undivided_estate_agreement": "Din samtykkeerklæring skal underskrives."
				}
			},
			"digital_document_review": {
				"pre_booked": "Du skal udfylde hele {product} inden dit juridiske tjek.",
				"post_booking": "Når du er tilfreds med {product} skal du booke tid til dit møde."
			},
			"digital_document_advice": {
				"pre_booked": "Du kan fortsat redigere {product} frem til dit møde.",
				"post_booking": "Når du er tilfreds med {product} skal du booke tid til dit møde."
			}
		},
		"support": {
			"title": "Har du brug for hjælp? Vi er altid klar.",
			"call": "Ring til os på 88 62 60 50",
			"opening_hours": "Mandag - fredag: 9-16<br />Mandag - torsdag 18-21"
		},
		"errors": {
			"title": "Et øjeblik",
			"conditions": "Du mangler at acceptere handelsbetingelserne",
			"conditions_short": "Accepter betingelser",
			"purchase_type": "Du skal vælge hvilke pakke du ønsker, for alle dokumenterne",
			"empty": "Din kurv er tom",
			"booking": "Du mangler at vælge et tidspunkt for dit møde"
		},
		"conditions_prefix": "Jeg accepterer",
		"conditions": "handelsbetingelserne",
		"empty": "Kurven er tom",
		"total": "Pris i alt",
		"total_currency": "DKK {amount}",
		"sub_total": "Subtotal",
		"discount_label": "Rabat",
		"cta": "Gå til betaling",
		"choose_package": {
			"title": "Du skal vælge en pakke",
			"description": "Hos TestaViva vælger du en pakke til hvert dokument så du får en service efter dit behov. Den pakke du vælger afgør din pris.",
			"amount": "{amount},-",
			"packages": {
				"title": {
					"digital_document_basis": "Selvbetjening",
					"digital_document_review": "Juridisk tjek",
					"digital_document_advice": "Udvidet rådgivning"
				},
				"description": {
					"digital_document_basis": "Du udfylder selv dit dokument og gør det selv juridisk gyldigt, men TestaViva guider dig hele vejen.",
					"digital_document_review": "Du udfylder selv dit dokument, men får derefter 15 minutters telefonisk juridisk tjek af en jurist der sikrer at alt er korrekt.",
					"digital_document_advice": "Som en del af denne pakke får du sammen med oprettelsen af dit dokument personlig og udvidet juridisk rådgivning."
				}
			},
			"most_popular": "Mest populære"
		},
		"items": {
			"choose": "Vælg pakke",
			"choose_your": "Vælg din pakke",
			"registration_cost": "Tinglysning: <span class='ml-auto'>{amount}</span>",
			"registration_fee": "Retsafgift: <span class='ml-auto'>{amount}</span>",
			"subscription_title": "12 måneders gratis premium",
			"subscription_items": {
				"digital_document_basis": {
					"1": "- Opbevaring af dokument",
					"2": "- Fremsendelse til skifteretten"
				},
				"digital_document_review": {
					"1": "- Fri support",
					"2": "- Løbende juridisk juridisk tjek",
					"3": "- Opbevaring af dokument",
					"4": "- Fremsendelse til skifteretten"
				},
				"digital_document_advice": {
					"1": "- Fri support",
					"2": "- Løbende juridisk rådgivning",
					"3": "- Opbevaring af dokument",
					"4": "- Fremsendelse til skifteretten"
				}
			},
			"description": {
				"null": "Vælg den pakke du ønsker for dette dokument.",
				"digital_document_basis": "Når du køber Selvbetjening, får du fuld adgang til dokumentet og alle relaterede funktioner. Du får adgang til at se og hente dit dokument, og vi guider dig hele vejen til det er juridisk gyldigt.",
				"digital_document_review": "Når du køber Juridisk tjek, har du adgang til alle de samme funktioner som ved køb af Selvbetjening. Du får derudover et 15 minutters telefonmøde med en jurist, der gennemgår dokumentet med dig.",
				"digital_document_advice": "Når du køber Udvidet rådgivning, har du adgang til alle de samme funktioner som ved køb af Selvbetjening. Du kan derudover booke et telefonisk rådgivningsmøde hvor en jurist giver dig konkret rådgivning om dine ønsker og behov.",
				"upgrade_to_review": "Når du opgrader til Juridisk tjek, får du et juridisk tjek af en jurist, der sikrer at du har truffet de rette valg.",
				"upgrade_to_advice": "Når du opgrader til Rådgivning, får du fuld juridisk rådgivning af en jurist, der kan svare på alle dine spørgsmål.",
				"registration": "Når du betaler for tinglysning hos TestaViva, slipper du for besværet med offentlige systemer. TestaViva klarer det hele for dig, og fortæller dig, når du skal underskrive med dit NemID.",
				"court_fee": "Når du betaler for tinglysning hos TestaViva, slipper du for besværet med offentlige systemer. TestaViva klarer det hele for dig, og fortæller dig, når du skal underskrive med dit NemID.",
				"package": "Dette produkt indgår som en del af din rådgivningspakke."
			},
			"select_service": "Hvilken pakke ønsker du med dit dokument?",
			"cta": "Vælg"
		},
		"booking": {
			"title": "Mødebooking",
			"subline": "Book tid til dit rådgivningsmøde.",
			"cta": "Book tid",
			"description": "Du skal vælge hvilket tidspunkt du ønsker at booke et møde. Det foregår via telefon og vores jurist ringer dig op på det tidspunkt du vælger.",
			"pre_selected_time": "Du har en aftale d. {day}/{month} kl. {hour}.{minutes}",
			"selected_time": "Du har valgt d. {day}/{month} kl. {hour}.{minutes}",
			"selected": "Du har nu valgt dato og tidspunkt for dit møde. Vores rådgiver vil ringe dig op på det\nvalgte tidspunkt.\n",
			"pre_selected": "Du har tidligere booket et møde. Hvis du ønsker at ændre dette tidspunkt, skal du\nhenvende dig til vores support. Vores rådgiver vil ringe dig op på det aftalte tidspunkt.\n",
			"disclaimer": "OBS. Det er meget vigtig at du sidder klar med dokumentet, når juristen ringer dig op. Så sikrer vi at tiden\nbruges på det juridiske tjek og ikke teknisk support.\n",
			"save": "Bekræft",
			"error": "Du skal vælge et tidspunkt.",
			"delete": "slet"
		},
		"phone": {
			"title": "Telefonnummer er påkrævet",
			"placeholder": "Telefon",
			"cta": "Gem",
			"error": "Du skal angive dit telefonnummer",
			"genericError": "Der skete en uventet fejl. Prøv venligst igen senere, eller henvend dig til support@testaviva.dk"
		}
	}
};